module.exports = __webpack_public_path__ + "img/header-engagementRings070Carat.b93f52d.jpg";